module.exports = __webpack_public_path__ + "img/Indicator Comparison.6d73eb92.png";